import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { mixins } from '@styles/mixins';
import { withTheme } from '@emotion/react';
import React from 'react';
import { ThemeProps } from '@theme/base';
import { Icon } from '@components/common/generic-icon';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  flex: 1,
  [mq.medium]: {
    height: '100%'
  }
});

const Title = styled.div(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xSmall,
  ...mixins(theme).truncate,
  marginTop: 0,
  ...(theme.custom.typography.h5 as any)
}));

const Text = styled.p(({ theme }: ThemeProps) => ({
  flexGrow: 1,
  ...(theme.custom.typography.paragraph as any).copy,
  marginBottom: 0,
  width: '100%'
}));

const StyledIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  color: theme.custom.states.info.dark,
  marginBottom: 10,
  fontSize: '6rem'
}));

export interface BenefitsProps {
  icon: string;
  title: string;
  detail: string;
}

export const BenefitsComponent = ({ icon, title, detail }: BenefitsProps) => {
  const t: any = useI18NextContext();
  return (
    <Container data-testid={TestId.benefits}>
      <StyledIcon name={icon} />
      <Title>{t(title)}</Title>
      <Text>{t(detail)}</Text>
    </Container>
  );
};

export const BaseBenefit = withTheme(BenefitsComponent);
